import { commitMutation, graphql } from "react-relay";
import environment from "../AuthEnv";
import { GC_AUTH_TOKEN, GC_USER_ID, GRAPHQL_PATH } from "../constants";
 
const mutation = graphql`
  mutation AddSmallScreenSubMutation($input: AddSubscriptionInput!) {
    addSubscription(input: $input) {
      subEdge {
        cursor
        node {
          id
          name
          source {
            id
            name
            image_url
            source_icon
          }
          parent {
            id
          }
        }
      }
    }
  }
`;
 
export default (subName, parent, source, callback) => {
    const variables = {
        input: {
            subName: subName,
            parent: parent,
            source: source
        }
    };
 
    commitMutation(environment, {
        mutation,
        // optimisticResponse,
        variables,
        onCompleted: (response, errors) => {
            if (response.addSubscription != null) {
                callback();
            } else {
                console.log("Unable to create new Category!");
            }
        },
        onError: err => console.error(err)
    });
};

